import React from "react";
import UnderConstruction from "../components/UnderConstruction";

const MediaKitPage = () => {
  return (
    <UnderConstruction 
      title="Media Kit"
      description="Our comprehensive media kit with logos, brand guidelines, and press resources will be available soon for partners and media professionals."
      expectedLaunch="Coming Soon"
    />
  );
};

export default MediaKitPage;